import { permissionsRoutes } from '~/shared/constants/permissionsRoutes';

export function getAnyValidRouteWithPermission(
  userPermissionsIds: string[]
): string {
  if ((userPermissionsIds || []).length === 0) {
    return undefined;
  }

  const findPermission = Object.keys(permissionsRoutes).find((permission) => {
    return userPermissionsIds.find(
      (permisisonId) => permisisonId === permission
    );
  });

  return findPermission && permissionsRoutes[findPermission];
}
